import React from "react";
import { Typography, Container, Grid } from "@mui/material";

import olamLogo from "../../assets/landing/logo/olam-logo.png";
import hyfunLogo from "../../assets/landing/logo/hyfun-logo.png";
import aryaagLogo from "../../assets/landing/logo/aryaag-logopng.png";
import staragriLogo from "../../assets/landing/logo/Staragri-logo.png";
import maricoLogo from "../../assets/landing/logo/marico-logo.png";
import { useTranslation } from "react-i18next";

const ClientsSection = () => {
  const { t } = useTranslation();
  return (
    <Container sx={{ marginTop: "8.125rem" , marginBottom: "3.75rem" }}>
      {/* Main heading */}
      <Typography
        align="center"
        sx={{
          fontWeight: "bold",
          color: "#191A15",
          fontSize: "40px",
        }}
      >
        {t("More than 1,25,000 farmers registered")}
      </Typography>

      {/* Logo Section */}
      <Grid
        container
        spacing={2}
        justifyContent="center"
        alignItems="center"
        sx={{display:"flex", justifyContent:'space-between' }}
      >
        <Grid item xs={6} sm={2.4}>
          <img
            src={olamLogo}
            alt="Olam"
            style={{
              height: "auto",
              width: "100%",
              objectFit: "cover",
              opacity: 0.4,
              filter: "grayscale(100%)",
            }}
          />
        </Grid>

        <Grid item xs={6} sm={2.4}>
          <img
            src={hyfunLogo}
            alt="Hyfun"
            style={{
              height: "auto",
              width: "100%",
              objectFit: "cover",
              opacity: 0.4,
              filter: "grayscale(100%)",
            }}
          />
        </Grid>

        <Grid item xs={6} sm={2.4}>
          <img
            src={aryaagLogo}
            alt="Arya.ag"
            style={{
              height: "autox",
              width: "100%",
              objectFit: "cover",
              opacity: 0.4,
              filter: "grayscale(100%)",
            }}
          />
        </Grid>

        <Grid item xs={6} sm={2.4}>
          <img
            src={staragriLogo}
            alt="StarAgri"
            style={{
              height: "auto",
              width: "100%",
              objectFit: "cover",
              opacity: 0.4,
              filter: "grayscale(100%)",
            }}
          />
        </Grid>

        <Grid item xs={6} sm={2.4}>
          <img
            src={maricoLogo}
            alt="Marico"
            style={{
              height: "auto",
              width: "100%",
              objectFit: "cover",
              opacity: 0.4,
              filter: "grayscale(100%)",
            }}
          />
        </Grid>
      </Grid>
    </Container>
  );
};

export default ClientsSection;
